<template>
  <nav class="nav-menu">
    <HamburgerMenu v-if="isMobile" />
    <div v-if="!isMobile">
      <router-link to="/">Home</router-link> |
      <router-link to="/band">The Band</router-link> |
      <router-link to="/discography">Discography</router-link> |
      <router-link to="/news">News</router-link> |
      <router-link to="/tour">Tour</router-link> |
      <router-link to="/media">Media</router-link> |
      <router-link to="/fanZone">Fan Zone</router-link> |
      <router-link to="/contact">Contact</router-link>
    </div>
  </nav>
</template>

<script>
import { useWindowSize } from '@vueuse/core';
import HamburgerMenu from './HamburgerMenu.vue';

export default {
  name: 'NavMenu',
  components: {
    HamburgerMenu,
  },
  setup() {
    return {
      windowWidth: useWindowSize().width,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 893;
    },
  },
};
</script>

<style scoped>
.nav-menu {
  gap: 0.5rem;
  font-size: 1.3rem;
  padding: 1rem;
  justify-content: center;
}
nav a {
  font-family: 'Cinzel Decorative', cursive;
  font-weight: 700;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
